export default __webpack_public_path__ + "static/media/stars.211cf6aa.gif";